<template>
  <div class="box9" id="box9">
    <pageTitle
      title="就业薪资高"
      text="博学谷学生多领域真项目实操，相当于累积1-3年工作经验"
    />

    <div class="content">
      <div class="border">
        <div class="content-top">
          <div class="name name1">姓名</div>
          <div class="education">学历</div>
          <div class="before">大学专业</div>
          <div class="after">就业薪资</div>
          <div class="unit">入职公司</div>
        </div>
      </div>

      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems1">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in salaryList"
          :key="index"
        >
          <div class="item" v-for="(item, index) in salaryList" :key="index">
            <div class="name">{{ item.name }}</div>
            <div class="education">{{ item.education }}</div>
            <div class="before">{{ item.major }}</div>
            <div class="after">{{ item.after }}</div>
            <div class="unit">{{ item.unit }}</div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
     <p class="txt">
      *
      为了避免对学员造成影响，以上数据做了部分隐藏处理，相关数据来源于公司内部真实统计
    </p>
    <div class="swiper-content">
      <swiper :options="swiperOption2" ref="mySwiper2" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in 18"
          :key="index"
        >
          <img
            :src="require(`../../../assets/coursePage/java/box9/${index}.png`)"
            alt
          />
        </swiper-slide>
      </swiper>

      <div class="swiper-pagination-box12"></div>
    </div>
   
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },

  data() {
    return {
      swiperOption: {
        // swiper配置
        direction: "vertical", // 滑动方向改为垂直
        height: 72, //你的slide高度 强制性 垂直方向生效
        loop: true, //是否循环
        freeMode: true,
        speed: 30000,
        autoplay: {
          delay: 0, // 自动播放的时长
          stopOnLastSlide: false /* 触摸滑动后是否继续轮播 */,
          disableOnInteraction: false,
        },
        grabCursor: true,
        slidesPerView: "auto",
      },
      salaryList: [
        {
          name: "张**",
          education: "硕士",
          major: "生物医学",
          after: "18000",
          unit: "**科技有限公司",
        },
        {
          name: "罗**",
          education: "大专",
          major: "自动化",
          after: "10941",
          unit: "福建**有限公司",
        },
        {
          name: "刘**",
          education: "大专",
          major: "计算机",
          after: "13500",
          unit: "北京**有限公司",
        },
        {
          name: "徐**",
          education: "本科",
          major: "电子信息",
          after: "11000",
          unit: "安徽**信息科技",
        },
        {
          name: "王*",
          education: "本科",
          major: "数字媒体",
          after: "11000",
          unit: "浪**有限公司",
        },
        {
          name: "魏**",
          education: "本科",
          major: "空间信息",
          after: "10800",
          unit: "顺**有限公司",
        },
        {
          name: "李*",
          education: "本科",
          major: "自动化",
          after: "17000",
          unit: "比**有限公司",
        },
        {
          name: "闫**",
          education: "硕士",
          major: "通信工程",
          after: "16000",
          unit: "南大**GBase公司",
        },
        {
          name: "陈**",
          education: "本科",
          major: "通信工程",
          after: "11250",
          unit: "深圳**有限公司",
        },
        {
          name: "上官**",
          education: "硕士",
          major: "化工",
          after: "30万日元",
          unit: "保密",
        },
        {
          name: "孔**",
          education: "本科",
          major: "软件工程",
          after: "13000",
          unit: "维**有限公司",
        },
        {
          name: "刘**",
          education: "本科",
          major: "网络工程",
          after: "11000",
          unit: "天津**京分公司",
        },
        {
          name: "杨**",
          education: "本科",
          major: "大数据",
          after: "10500",
          unit: "新疆**责任公司",
        },
        {
          name: "蔡**",
          education: "本科",
          major: "知识产权",
          after: "13000",
          unit: "深圳***有限公司",
        },
        {
          name: "陶**",
          education: "本科",
          major: "网络安全",
          after: "12500",
          unit: "**南京研究所",
        },
        {
          name: "徐**",
          education: "本科",
          major: "软件工程",
          after: "12000",
          unit: "深圳**京分公司",
        },
        {
          name: "周**",
          education: "本科",
          major: "计科",
          after: "11500",
          unit: "浙江**有限公司",
        },
      ],
      swiperOption2: {
        loop: true, // 循环模式选项

        spaceBetween: 22,
        autoplay: true,
        centeredSlides: true,
        slidesPerView: "auto",
        coverflowEffect: {
          slideShadows: true, // 页面阴影效果
          rotate: 0, // 旋转的角度
          stretch: 50, // 拉伸   图片间左右的间距和密集度
          depth: 200, // 深度   切换图片间上下的间距和密集度
          modifier: 0.9, // 修正值 该值越大前面的效果越明显
        },
        pagination: {
          el: ".swiper-pagination-box12",
        },
      },
    };
  },
};
</script>

<style lang="less" scoped>
.box9 {
  padding: 80px 0 88px;

  width: 100%;
  background: url("../../../assets/coursePage/java/box9/bgc.png") no-repeat;
  background-size: cover;
   .txt {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #86909c;
    line-height: 36px;
    width: 654px;
    margin: 40px auto 0;
    text-indent: -22px;
    padding-left: 22px;
  }
  /deep/ .swiper-container-free-mode > .swiper-wrapper {
    -webkit-transition-timing-function: linear; /*之前是ease-out*/
    -moz-transition-timing-function: linear;
    -ms-transition-timing-function: linear;
    -o-transition-timing-function: linear;
    transition-timing-function: linear;
    margin: 0 auto;
  }

  .content {
    margin: 0 auto;
    width: 686px;
    height: 96px;
    height: 864px;
    background: #ffffff;
    box-shadow: 0px 8px 24px 0px rgba(64, 128, 255, 0.12);
    border-radius: 24px;
    overflow: hidden;
    margin-top: 48px;

    -webkit-backface-visibility: hidden;
    -webkit-transform: translate3d(0, 0, 0);

    .border {
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 1),
        rgba(255, 255, 255, 0)
      );

      padding: 2px;
      border-radius: 24px 24px 0 0;
      overflow: hidden;
      margin: -2px;
    }
    .swiperitems1 {
      border-radius: 0 0 24px 24px;
    }
    .swiperwrap {
      background-color: #ffffff !important;
      position: relative;
      z-index: 20;
    }
    .item {
      display: flex;

      text-align: center;
      height: 96px;
      background: #ffffff;
      line-height: 96px;
      font-family: PingFang SC;
      font-size: 24px;
      font-weight: normal;
      letter-spacing: 0px;
      color: #4e5969;
      box-sizing: border-box;
      border-bottom: 2px solid rgba(232, 243, 255, 0.8);
    }
    .name {
      width: 120px;
      height: 96px;
    }
    .name1 {
      border-radius: 24px 0 0 0;
    }
    .education {
      width: 80px;
      height: 96px;
    }
    .before {
      width: 128px;
      height: 96px;
    }
    .after {
      width: 128px;
      height: 96px;

      color: #165dff;
    }
    .unit {
      width: 230px;
      height: 96px;
    }

    .content-top {
      display: flex;
      height: 96px;
      box-sizing: border-box;
      // background: linear-gradient(180deg, #d7e3ff 0%, #f3f7ff 100%);
      background: url("../../../assets/coursePage/java/box9/topbgc.png")
        no-repeat;
      background-size: cover;
      width: 100%;
      div {
        // flex: 1;
        text-align: center;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1d2129;
        line-height: 96px;
      }
    }
  }

  .swiper-content {
    position: relative;
    padding-bottom: 38px;
    margin-top: 80px;

    img {
      padding: 4px;
      width: 406px;
      height: 721px;
      // background: #f5f9ff;
      border-radius: 20px;
      box-sizing: border-box;
      transition: all 0.3s;
    }

    .swiper-slide {
      display: flex;
      align-items: center;
      padding: 4px;
      width: 411px;
      height: 780px;
      // background: #f5f9ff;
      border-radius: 20px;
      box-sizing: border-box;
    }
    .swiper-slide-active {
      img {
        width: 450px;
        height: 790px;
        border-radius: 28px;
        margin-left: -22px;
      }
    }
    .swiper-pagination-box12 {
      display: flex;
      align-items: center;
      position: absolute;
      left: 50%;
      bottom: 0px;
      transform: translate(-50%, 0px);
      background: rgba(46, 165, 252, 0.16);
      // width: 60px;
      // height: 6px;

      // // background: #70c3f7;
      // background: rgba(46, 165, 252, 0.16);
      // border-radius: 3px;
    }
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: rgba(46, 165, 252, 0.16);
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #4b84fa;
    border-radius: 3px;
  }
}
</style>
